import { Component, computed, input } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import {
  isWorkflowIconAssetKey,
  normalizeWorkflowIconKeyForUi,
  resolveWorkflowIconAssetUrl,
} from '../../../../shared/utils/workflow-icon-key.util';

/**
 * Renderiza ícone de workflow: Lucide (kebab-case) ou imagem (URL/path de asset).
 */
@Component({
  selector: 'app-workflow-icon-display',
  standalone: true,
  imports: [LucideAngularModule],
  template: `
    @if (assetSrc()) {
      <img [src]="assetSrc()!" [alt]="altText()" [class]="imgClass()" />
    } @else {
      <lucide-icon [name]="lucideName()" [class]="glyphClass()"></lucide-icon>
    }
  `,
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }
      img {
        object-fit: cover;
        border-radius: 4px;
      }
    `,
  ],
})
export class WorkflowIconDisplayComponent {
  /** Valor já normalizado para UI ou bruto (semantic/asset/lucide). */
  readonly iconKey = input.required<string>();
  readonly glyphClass = input<string>('h-4 w-4');
  readonly imgClass = input<string>('h-4 w-4 w-full max-h-full');
  readonly altText = input<string>('');

  readonly assetSrc = computed(() => {
    const key = normalizeWorkflowIconKeyForUi(this.iconKey());
    return resolveWorkflowIconAssetUrl(key);
  });

  readonly lucideName = computed(() => {
    const key = normalizeWorkflowIconKeyForUi(this.iconKey());
    if (isWorkflowIconAssetKey(key)) return 'columns-3';
    return key;
  });
}
